import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'utcDateTime',
  standalone: true,
})
export class UtcDateTimePipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  private getTimeZoneAbbr(timeZone: string): string {
    // Map of IANA timezone names to their abbreviations
    const timeZoneMap: { [key: string]: string } = {
      'Asia/Kolkata': 'IST',
      'Asia/Calcutta': 'IST',
      'America/Los_Angeles': 'PST',
      'America/New_York': 'EST',
      'Europe/London': 'GMT',
      'Asia/Dubai': 'GST',
      'Asia/Singapore': 'SGT',
      'Australia/Sydney': 'AEST',
      'Pacific/Auckland': 'NZST',
      'Europe/Paris': 'CET',
      'Asia/Tokyo': 'JST'
    };

    // If we have a mapping, use it
    if (timeZoneMap[timeZone]) {
      return timeZoneMap[timeZone];
    }

    // If no mapping exists, try to get abbreviation from the date
    const date = new Date();
    const options = { timeZone, timeZoneName: 'short' as const };
    const timeZoneAbbr = new Intl.DateTimeFormat('en-US', options)
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value;

    return timeZoneAbbr || timeZone;
  }

  transform(value: string | number | Date | undefined): string | undefined {
    if (value) {
      const date = new Date(value);
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timeZoneAbbr = this.getTimeZoneAbbr(timeZone);

      // Format the date in local timezone
      const formatted = this.datePipe.transform(date, 'dd MMM yyyy, hh:mm:ss a', timeZone);
      return formatted ? `${formatted} ${timeZoneAbbr}` : undefined;
    }
    return undefined;
  }
}
